import { ColumnDefinition, FieldRenderer } from '../types';
import { DevHubTooltip, DevHubTypography } from '@devxdiscover/devhub-ui';
import { Column } from 'primereact/column';

/**
 * Renders the description field
 * @param col The column definition
 * @param index The index of the column
 */
export const descriptionRenderer: FieldRenderer = (
  col: ColumnDefinition,
  index: number,
) => {
  return (
    <Column
      key={index}
      field={col.field}
      header={col.header}
      style={{ width: col.width }}
      body={row => (
        <DevHubTooltip title={row.description}>
          <span>
            <DevHubTypography fontSize="small">
              {(row.description ?? '').substring(0, 80)}
              {(row.description?.length ?? 0) > 80 ? '...' : ''}
            </DevHubTypography>
          </span>
        </DevHubTooltip>
      )}
    />
  );
};
